<template>
  <div class="startup-public-profile">
    <Topnav placement="top" />
    <StartupProfile :can-user-see-private-data="canUserSeePrivateData" />
    <PageFooter />
    <ScrollTopButton />
  </div>
</template>

<script>
import Topnav from '@/Topnav'
import StartupProfile from '@/modules/startup-profile/StartupProfile'
import { mapState } from 'vuex'

export default {
  components: { StartupProfile, Topnav },
  props: {
    canUserSeePrivateData: { type: Boolean, default: false },
  },
  computed: mapState({
    startup: (state) => state.startupProfile.data,
  }),
}
</script>
